const urlConfig = {
  serviceUrlTargetX: '',
  serviceUrlSLM: ''
};

export default urlConfig;